import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokUserKeywords.graphql';
import { Query, QuerytiktokUserKeywordsArgs } from '../../__generated__/globalTypes';

export const useTiktokUserKeywordsQuery = (options?: QueryHookOptions<Query, QuerytiktokUserKeywordsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokUserKeywordsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokUserKeywordsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokUserKeywordsArgs>
): QueryResult<Query, QuerytiktokUserKeywordsArgs> & {
  getTiktokUserKeywords: LazyQueryExecFunction<Query, QuerytiktokUserKeywordsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokUserKeywords, result] = useLazyQuery<Query, QuerytiktokUserKeywordsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokUserKeywords, ...result };
};

export const useTiktokUserKeywordsPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokUserKeywords = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokUserKeywordsArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokUserKeywordsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokUserKeywords };
};
// Suspense Query Hooks
export const useTiktokUserKeywordsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokUserKeywordsArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokUserKeywordsArgs>(QUERY, {
    ...options
  });

  return result;
};
